import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Fade } from 'reactstrap';
import Loading from '../../components/Loading';
import FormRequest from '../../components/ManualAccesComponents/FormRequest';
// import LabelPinRequestOK from '../../components/ManualAccesComponents/LabelPinRequestOK';
// import NotificationAlert from '../../components/NotificationAlert';

import {
  setPropsFormPhoneNumerRequest,
  setPropsFormPinRequest,
  _onChangeInputPhone,
  _onChangeInputPin,
  _getPinForAuthorize,
  _getCodeOfAuthorize,
  _goToUrlToSubscription,
  _editPhoneNumber,
  _onChangeCheckBox,
  _onChangeEmail
} from './actions';

import {
  selectFormPhoneRequestConfig,
  selectLoading,
  selectPinForAuthorizeLoaded,
  selectPhoneNumber,
  selectPinNumber,
  selectpinForAuthorizeError,
  selectUrlFormToSubscription,
  selectInitialDataConfig,
  selectContactMeByTelOnly,
  selectEmail
} from './selectors';

// IMPORTS DE ESTILOS E IMAGENES:
import './style.scss';

/**
 * Representa el componente container Home
 *
 * @class ManualAccessPage
 * @extends {React.Component}
 */
export class ManualAccessPage extends React.Component {
  componentWillMount() {
    const { actions } = this.props;
    actions.setPropsFormPhoneNumerRequest();

    if (/Android 4\.[0-3]/.test(navigator.appVersion)) {
      window.addEventListener('resize', () => {
        if (document.activeElement.tagName === 'INPUT') {
          window.setTimeout(() => {
            document.activeElement.scrollIntoViewIfNeeded();
          }, 0);
        }
      });
    }
  }

  render() {
    let actionsFailureRedirect;

    const {
      loading,
      formPhoneRequestConfig,
      actions,
      pinForAuthorizeLoaded,
      propsLabelPinRequestOK,
      pinNumber,
      pinForAuthorizeError,
      urlFormToSubscription,
      failureRedirect,
      contactMeByTelOnly,
      email
    } = this.props;

    /*
    Usar el siguiente fragmento de codigo para cuando se active el go to failureRedirect

    if (failureRedirect) {
      actionsFailureRedirect = {
        extraActiontext: 'Voltar',
        _onClickExtraAction: () => { window.open(failureRedirect, '_self'); }
      };
    }
    */
    const actionsPhoneRequest = {
      _onChange: actions.onChangeInputPhone,
      _onClick: urlFormToSubscription
        ? () => { window.location = urlFormToSubscription; }
        : actions.getPinForAuthorize,
      _onChangeCheckBox: actions.onChangeCheckBox,
      _onChangeEmail: actions.onChangeEmail
    };

    const actionsPinRequest = {
      _onChange: actions.onChangeInputPin,
      _onClick: actions.getCodeOfAuthorize,
      _onChangeCheckBox: actions.onChangeCheckBox,
      _onChangeEmail: actions.onChangeEmail
    };

    return (
      <div className="manual_access">
        <div className="form-group">
          {
            (formPhoneRequestConfig && !pinForAuthorizeLoaded)
            && (
              <Fade tab="div" className="col-xs-12 col-sm-12 col-md-offset-3 col-md-6 col-lg-offset-4 col-lg-4">
                <FormRequest
                  {...formPhoneRequestConfig}
                  {...actionsPhoneRequest}
                  {...failureRedirect}
                  pinForAuthorizeError={{ ...pinForAuthorizeError }}
                  valNumber={propsLabelPinRequestOK.phoneNumber}
                  valueCheckBox={contactMeByTelOnly}
                  valueEmail={email}
                  {...actionsFailureRedirect}
                  activateRecaptcha="true"
                />
              </Fade>
            )
          }

          {
            pinForAuthorizeLoaded
            && (
              <Fade tab="div" className="col-xs-12 col-sm-12 col-md-offset-3 col-md-6 col-lg-offset-4 col-lg-4">
                {
                  /*
                  <LabelPinRequestOK
                    {...propsLabelPinRequestOK}
                    _onClick={actions.editPhoneNumber}
                  />
                  */
                }
                <FormRequest
                  {...formPhoneRequestConfig}
                  {...actionsPinRequest}
                  valNumber={pinNumber}
                  extraActiontext="Editar número e gerar novo PIN"
                  pinForAuthorizeError={{ ...pinForAuthorizeError }}
                  valueCheckBox={contactMeByTelOnly}
                  valueEmail={email}
                  _onClickExtraAction={actions.getPinForAuthorize}
                  activateRecaptcha="false"
                />
              </Fade>
            )
          }

        </div>
        {
          /*
          pinForAuthorizeError
          && (
            <Fade className="col-xs-12 col-sm-12 col-md-offset-3 col-md-6 col-lg-offset-4 col-lg-4">
              <br />
              <NotificationAlert {...pinForAuthorizeError} />
            </Fade>
          )
          */
        }
        <Loading isVisible={loading} />
      </div>
    );
  }
}

ManualAccessPage.propTypes = {
  actions: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
  loading: selectLoading(state),
  propsLabelPinRequestOK: {
    phoneNumber: selectPhoneNumber(state)
  },
  pinNumber: selectPinNumber(state),
  pinForAuthorizeLoaded: selectPinForAuthorizeLoaded(state),
  formPhoneRequestConfig: selectFormPhoneRequestConfig(state),
  pinForAuthorizeError: selectpinForAuthorizeError(state),
  urlFormToSubscription: selectUrlFormToSubscription(state),
  failureRedirect: selectInitialDataConfig(state) ? selectInitialDataConfig(state).failureRedirect : null,
  contactMeByTelOnly: selectContactMeByTelOnly(state),
  email: selectEmail(state)
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({
    setPropsFormPhoneNumerRequest,
    setPropsFormPinRequest,
    onChangeInputPhone: _onChangeInputPhone,
    onChangeCheckBox: _onChangeCheckBox,
    onChangeEmail: _onChangeEmail,
    onChangeInputPin: _onChangeInputPin,
    getPinForAuthorize: _getPinForAuthorize,
    getCodeOfAuthorize: _getCodeOfAuthorize,
    editPhoneNumber: _editPhoneNumber,
    goToUrlToSubscription: _goToUrlToSubscription
  }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ManualAccessPage);



// WEBPACK FOOTER //
// ./src/containers/ManualAccessPage/index.js